import { InvoiceDetailsComponent } from './invoices/invoice-details/invoice-details.component';
import { PosPaymentTfgVisionComponent } from './components/pos-capture-payment/pos-payment-tfg-vision/pos-payment-tfg-vision.component';
import { PosPaymentCashComponent } from './components/pos-capture-payment/pos-payment-cash/pos-payment-cash.component';
import { PosPaymentEftComponent } from './components/pos-capture-payment/pos-payment-eft/pos-payment-eft.component';
import { NgModule } from '@angular/core';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { SearchStockCodeEcomMenuComponent } from './components/search-stock-code-ecom-menu/search-stock-code-ecom-menu.component';
import { SalesOrdersComponent } from './sales-orders/sales-orders.component';
import { SalesOrderHeaderDialogComponent } from './sales-orders/sales-order-header-dialog/sales-order-header-dialog.component';
import { PosSearchCustomerDialogComponent } from './components/pos-search-customer-dialog/pos-search-customer-dialog.component';
import { SalesOrderCustomerDialogComponent } from './sales-orders/sales-order-customer-dialog/sales-order-customer-dialog.component';
import { SalesOrderAddressDialogComponent } from './sales-orders/sales-order-address-dialog/sales-order-address-dialog.component';
import { SalesOrderScanStockCodeDialogComponent } from './sales-orders/sales-order-scan-stock-code-dialog/sales-order-scan-stock-code-dialog.component';
import { SalesOrderSearchStockCodeDialogComponent } from './sales-orders/sales-order-search-stock-code-dialog/sales-order-search-stock-code-dialog.component';
import { PosStoreService } from './pos.store.service';
import { SalesOrderLineDialogComponent } from './sales-orders/sales-order-line-dialog/sales-order-line-dialog.component';
import { SalesOrderHeaderCustomerDetailsDialogComponent } from './sales-orders/sales-order-header-customer-details-dialog/sales-order-header-customer-details-dialog.component';
import { SalesOrderDeliverFeeDialogComponent } from './sales-orders/sales-order-deliver-fee-dialog/sales-order-deliver-fee-dialog.component';
import { SalesOrderLineDiscountDialogComponent } from './sales-orders/sales-order-line-discount-dialog/sales-order-line-discount-dialog.component';
import { PosCapturePaymentComponent } from './components/pos-capture-payment/pos-capture-payment.component';
import { PosAddDepositDialogComponent } from './components/pos-add-deposit-dialog/pos-add-deposit-dialog.component';
import { PosPaymentCardComponent } from './components/pos-capture-payment/pos-payment-card/pos-payment-card.component';
import { PosTfgAccountDetailsComponent } from './components/pos-tfg-account-details/pos-tfg-account-details.component';
import { SalesOrderInvoiceLinesDialogComponent } from './sales-orders/sales-order-invoice-lines-dialog/sales-order-invoice-lines-dialog.component';
import { PosInvoicePayWithDepositDialogComponent } from './components/pos-invoice-pay-with-deposit/pos-invoice-pay-with-deposit-dialog.component';
import { PosInvoicePayWithMoneyEquipmentComponent } from './components/pos-invoice-pay-with-money-equipment/pos-invoice-pay-with-money-equipment.component';
import { SalesOrderCancelDialogComponent } from './sales-orders/sales-order-cancel-dialog/sales-order-cancel-dialog.component';
import { TfgAccountComponent } from './tfg-account/tfg-account.component';
import { PosTfgAccountPayWithMoneyEquipmentComponent } from './components/pos-tfg-account-pay-with-money-equipment/pos-tfg-account-pay-with-money-equipment.component';
import { SalesOrderCommentsDialogComponent } from './sales-orders/sales-order-comments-dialog/sales-order-comments-dialog.component';
import { SysproOrderLineDiscountDialogComponent } from './syspro-orders/syspro-order-line-discount-dialog/syspro-order-line-discount-dialog.component';
import { SysproOrderLineDialogComponent } from './syspro-orders/syspro-order-line-dialog/syspro-order-line-dialog.component';
import { SendEmailConfirmDialogComponent } from './components/send-email-confirm-dialog/send-email-confirm-dialog.component';
import { SalesOrderHeaderDetailsDialogComponent } from './sales-orders/sales-order-header-details-dialog/sales-order-header-details-dialog.component';
import { InvoiceCreateCreditNoteDialogComponent } from './invoices/invoice-details/invoice-create-credit-note-dialog/invoice-create-credit-note-dialog.component';
import { PosInvoiceRefundWithMoneyContainerComponent } from './components/pos-invoice-refund-with-money-container/pos-invoice-refund-with-money-container.component';
import { InvoiceEftRequestDialogComponent } from './invoices/invoice-details/invoice-eft-request-dialog/invoice-eft-request-dialog.component';
import { SalesOrderTransferDepositDialogComponent } from './sales-orders/sales-order-transfer-deposit-dialog/sales-order-transfer-deposit-dialog.component';
import { PosRefundDepositDialogComponent } from './components/pos-refund-deposit-dialog/pos-refund-deposit-dialog.component';
import { SalesOrderEftRequestDialogComponent } from './sales-orders/sales-order-eft-request-dialog/sales-order-eft-request-dialog.component';
import { TfgPaymentReversalComponent } from './tfg-account/tfg-payment-reversal/tfg-payment-reversal.component';
import { SalesOrderEcomStockCodeSearchDialogComponent } from './sales-orders/sales-order-ecom-stock-code-search-dialog/sales-order-ecom-stock-code-search-dialog.component';
import { SysproOrderUploadSupportingDocumentDialogComponent } from './syspro-orders/syspro-order-upload-supporting-document-dialog/syspro-order-upload-supporting-document-dialog.component';
import { SysproOrderDeliverFeeDialogComponent } from './syspro-orders/syspro-order-deliver-fee-dialog/syspro-order-deliver-fee-dialog.component';
import { SalesOrderMiscChargeDialogComponent } from './sales-orders/sales-order-misc-charge-dialog/sales-order-misc-charge-dialog.component';
import { SendSmsConfirmDialogComponent } from './components/send-sms-confirm-dialog/send-sms-confirm-dialog.component';
import { SalesOrderAddNoteDialogComponent } from './sales-orders/sales-order-add-note-dialog/sales-order-add-note-dialog.component';
import { SalesOrderCreateDialogComponent } from './sales-orders/sales-order-create-dialog/sales-order-create-dialog.component';
import { SalesOrderLineDetailDialogComponent } from './sales-orders/sales-order-line-detail-dialog/sales-order-line-detail-dialog.component';
import { SctConfirmDialogComponent } from './components/sct-confirm-dialog/sct-confirm-dialog.component';
import { GtrReceiveDialogComponent } from './components/gtr-receive-dialog/gtr-receive-dialog.component';
import { PosPaymentOzowComponent } from './components/pos-capture-payment/pos-payment-ozow/pos-payment-ozow.component';
import { PosPaymentZapperComponent } from './components/pos-capture-payment/pos-payment-zapper/pos-payment-zapper.component';
import { SctSearchStockCodeDialogComponent } from './components/sct-search-stock-code-dialog/sct-search-stock-code-dialog.component';
import { ActionEftRequestDialogComponent } from './components/action-eft-request-dialog/action-eft-request-dialog.component';
import { FinanceFreeMoneyToAccountDialogComponent } from './components/finance-free-money-to-account-dialog/finance-free-money-to-account-dialog.component';
import { PosCashUpReportDialogComponent } from './components/pos-cash-up-report-dialog/pos-cash-up-report-dialog.component';
import { PosOperatorTransactionsReportDialogComponent } from './components/pos-operator-transactions-report-dialog/pos-operator-transactions-report-dialog.component';
import { InvoiceTransferCreditToDepositComponent } from './invoices/invoice-details/invoice-transfer-credit-to-deposit/invoice-transfer-credit-to-deposit.component';
import { PosAccountPayWithMoneyEquipmentDialogComponent } from './components/pos-account-pay-with-money-equipment-dialog/pos-account-pay-with-money-equipment-dialog.component';
import { PosPaymentRcsComponent } from './components/pos-capture-payment/pos-payment-rcs/pos-payment-rcs.component';
import { RcsAccountComponent } from './rcs-account/rcs-account.component';
import { PosRcsAccountPaymentWithMoneyEquipmentComponent } from './components/pos-rcs-account-payment-with-money-equipment/pos-rcs-account-payment-with-money-equipment.component';
import { SysproOrderMiscChargeDialogComponent } from './syspro-orders/syspro-order-misc-charge-dialog/syspro-order-misc-charge-dialog.component';
import { TfgRewardsComponent } from './tfg-rewards/tfg-rewards.component';
import { PosTfgRewardsDetailsDialogComponent } from './components/pos-tfg-rewards-details-dialog/pos-tfg-rewards-details-dialog.component';
import { PosPaymentPayjustnowComponent } from './components/pos-capture-payment/pos-payment-payjustnow/pos-payment-payjustnow.component';
import { PosTfgCampaignDetailsComponent } from './components/pos-tfg-campaign-details/pos-tfg-campaign-details.component';
import { PosTfgCampaignDetailsLinesBreakdownComponent } from './components/pos-tfg-campaign-details/pos-tfg-campaign-details-lines-breakdown/pos-tfg-campaign-details-lines-breakdown.component';
import { PosTfgRewardsCheckVoucherComponent } from './components/pos-tfg-rewards-check-voucher/pos-tfg-rewards-check-voucher.component';
import { PosTfgRewardsViewVoucherComponent } from './components/pos-tfg-rewards-view-voucher/pos-tfg-rewards-view-voucher.component';
import { PosPaymentYoyoComponent } from './components/pos-capture-payment/pos-payment-yoyo/pos-payment-yoyo.component';
import { SalesOrderAddNonStockLineComponent } from './sales-orders/sales-order-add-non-stock-line/sales-order-add-non-stock-line.component';
import { SalesOrderLedaineLineDetailDialogComponent } from './sales-orders/sales-order-ledaine-line-detail-dialog/sales-order-ledaine-line-detail-dialog.component';
import { InvoiceCreateCreditNoteLedaineDialogComponent } from './invoices/invoice-details/invoice-create-credit-note-ledaine-dialog/invoice-create-credit-note-ledaine-dialog.component';
import { InvoiceCreateCreditNoteWarningsDialogComponent } from './invoices/invoice-details/invoice-create-credit-note-warnings-dialog/invoice-create-credit-note-warnings-dialog.component';

export const routes = [
  { path: 'orders/:id', component: SalesOrdersComponent },
  { path: 'orders/:source/:id', component: SalesOrdersComponent },
  { path: 'tfg/account', component: TfgAccountComponent },
  { path: 'tfg/rewards', component: TfgRewardsComponent },
  { path: 'invoices/:invoiceNumber', component: InvoiceDetailsComponent },
  { path: 'rcs/account', component: RcsAccountComponent },
];

@NgModule({
  declarations: [
    SearchStockCodeEcomMenuComponent,
    SalesOrdersComponent,
    SalesOrderHeaderDialogComponent,
    PosSearchCustomerDialogComponent,
    SalesOrderAddressDialogComponent,
    SalesOrderCustomerDialogComponent,
    SalesOrderScanStockCodeDialogComponent,
    SalesOrderSearchStockCodeDialogComponent,
    SalesOrderLineDialogComponent,
    SalesOrderHeaderCustomerDetailsDialogComponent,
    SalesOrderHeaderDetailsDialogComponent,
    SalesOrderDeliverFeeDialogComponent,
    SalesOrderMiscChargeDialogComponent,
    SalesOrderLineDiscountDialogComponent,
    PosCapturePaymentComponent,
    PosAddDepositDialogComponent,
    PosPaymentCardComponent,
    PosPaymentEftComponent,
    PosPaymentOzowComponent,
    PosPaymentZapperComponent,
    PosPaymentCashComponent,
    PosPaymentTfgVisionComponent,
    PosTfgAccountDetailsComponent,
    SalesOrderInvoiceLinesDialogComponent,
    PosInvoicePayWithDepositDialogComponent,
    PosInvoicePayWithMoneyEquipmentComponent,
    SalesOrderCancelDialogComponent,
    TfgAccountComponent,
    PosTfgAccountPayWithMoneyEquipmentComponent,
    SalesOrderCommentsDialogComponent,
    InvoiceDetailsComponent,
    SysproOrderLineDiscountDialogComponent,
    SysproOrderLineDialogComponent,
    SysproOrderMiscChargeDialogComponent,
    SendEmailConfirmDialogComponent,
    InvoiceCreateCreditNoteDialogComponent,
    PosInvoiceRefundWithMoneyContainerComponent,
    InvoiceEftRequestDialogComponent,
    SalesOrderTransferDepositDialogComponent,
    PosRefundDepositDialogComponent,
    SalesOrderEftRequestDialogComponent,
    TfgPaymentReversalComponent,
    SalesOrderEcomStockCodeSearchDialogComponent,
    SysproOrderUploadSupportingDocumentDialogComponent,
    SendSmsConfirmDialogComponent,
    SalesOrderAddNoteDialogComponent,
    SalesOrderCreateDialogComponent,
    SalesOrderLineDetailDialogComponent,
    SctConfirmDialogComponent,
    GtrReceiveDialogComponent,
    SctSearchStockCodeDialogComponent,
    SysproOrderDeliverFeeDialogComponent,
    ActionEftRequestDialogComponent,
    FinanceFreeMoneyToAccountDialogComponent,
    PosCashUpReportDialogComponent,
    PosOperatorTransactionsReportDialogComponent,
    InvoiceTransferCreditToDepositComponent,
    PosAccountPayWithMoneyEquipmentDialogComponent,
    PosPaymentRcsComponent,
    RcsAccountComponent,
    PosRcsAccountPaymentWithMoneyEquipmentComponent,
    TfgRewardsComponent,
    PosTfgRewardsDetailsDialogComponent,
    PosPaymentPayjustnowComponent,
    PosTfgCampaignDetailsComponent,
    PosTfgCampaignDetailsLinesBreakdownComponent,
    PosTfgRewardsCheckVoucherComponent,
    PosTfgRewardsViewVoucherComponent,
    PosPaymentYoyoComponent,
    SalesOrderAddNonStockLineComponent,
    SalesOrderLedaineLineDetailDialogComponent,
    InvoiceCreateCreditNoteLedaineDialogComponent,
    InvoiceCreateCreditNoteWarningsDialogComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
  ],
  providers: [
    PosStoreService
  ]
})
export class PosModule { }
